@file:OptIn(InternalResourceApi::class)

package fr.frux.app.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.app.resources/"

@delegate:ResourceContentHash(-191_851_444)
internal val Res.string.profile_logout_all_dialog_text: StringResource by lazy {
      StringResource("string:profile_logout_all_dialog_text", "profile_logout_all_dialog_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7741, 150),
      ))
    }

@delegate:ResourceContentHash(1_370_861_950)
internal val Res.string.profile_logout_all_dialog_title: StringResource by lazy {
      StringResource("string:profile_logout_all_dialog_title", "profile_logout_all_dialog_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7892, 83),
      ))
    }

@delegate:ResourceContentHash(483_333_924)
internal val Res.string.profile_logout_all_done: StringResource by lazy {
      StringResource("string:profile_logout_all_done", "profile_logout_all_done", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7976, 91),
      ))
    }

@delegate:ResourceContentHash(423_241_453)
internal val Res.string.profile_member_since: StringResource by lazy {
      StringResource("string:profile_member_since", "profile_member_since", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8182, 56),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.profile_nudge_dismiss: StringResource by lazy {
      StringResource("string:profile_nudge_dismiss", "profile_nudge_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8239, 37),
      ))
    }

@delegate:ResourceContentHash(-1_425_698_870)
internal val Res.string.profile_nudge_enrich_cta: StringResource by lazy {
      StringResource("string:profile_nudge_enrich_cta", "profile_nudge_enrich_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8277, 52),
      ))
    }

@delegate:ResourceContentHash(-1_722_174_432)
internal val Res.string.profile_nudge_enrich_text: StringResource by lazy {
      StringResource("string:profile_nudge_enrich_text", "profile_nudge_enrich_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8330, 157),
      ))
    }

@delegate:ResourceContentHash(-1_232_578_894)
internal val Res.string.profile_nudge_enrich_title: StringResource by lazy {
      StringResource("string:profile_nudge_enrich_title", "profile_nudge_enrich_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8488, 70),
      ))
    }

@delegate:ResourceContentHash(1_690_221_056)
internal val Res.string.profile_nudge_first_cta: StringResource by lazy {
      StringResource("string:profile_nudge_first_cta", "profile_nudge_first_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8559, 55),
      ))
    }

@delegate:ResourceContentHash(-1_217_089_769)
internal val Res.string.profile_nudge_first_text: StringResource by lazy {
      StringResource("string:profile_nudge_first_text", "profile_nudge_first_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8615, 112),
      ))
    }

@delegate:ResourceContentHash(1_211_175_343)
internal val Res.string.profile_nudge_first_title: StringResource by lazy {
      StringResource("string:profile_nudge_first_title", "profile_nudge_first_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8728, 85),
      ))
    }

@delegate:ResourceContentHash(1_871_104_415)
internal val Res.string.profile_row_activity: StringResource by lazy {
      StringResource("string:profile_row_activity", "profile_row_activity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8900, 40),
      ))
    }

@delegate:ResourceContentHash(-1_192_717_635)
internal val Res.string.profile_row_activity_subtitle: StringResource by lazy {
      StringResource("string:profile_row_activity_subtitle", "profile_row_activity_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8814, 85),
      ))
    }

@delegate:ResourceContentHash(1_893_805_322)
internal val Res.string.profile_row_ad_choices: StringResource by lazy {
      StringResource("string:profile_row_ad_choices", "profile_row_ad_choices", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9041, 70),
      ))
    }

@delegate:ResourceContentHash(-127_086_551)
internal val Res.string.profile_row_ad_choices_subtitle: StringResource by lazy {
      StringResource("string:profile_row_ad_choices_subtitle", "profile_row_ad_choices_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8941, 99),
      ))
    }

@delegate:ResourceContentHash(-1_345_378_304)
internal val Res.string.profile_row_blocked_users: StringResource by lazy {
      StringResource("string:profile_row_blocked_users", "profile_row_blocked_users", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9207, 57),
      ))
    }

@delegate:ResourceContentHash(2_102_358_385)
internal val Res.string.profile_row_blocked_users_subtitle: StringResource by lazy {
      StringResource("string:profile_row_blocked_users_subtitle", "profile_row_blocked_users_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9112, 94),
      ))
    }

@delegate:ResourceContentHash(623_781_045)
internal val Res.string.profile_row_delete_account: StringResource by lazy {
      StringResource("string:profile_row_delete_account", "profile_row_delete_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9265, 62),
      ))
    }

@delegate:ResourceContentHash(1_532_135_813)
internal val Res.string.profile_row_export: StringResource by lazy {
      StringResource("string:profile_row_export", "profile_row_export", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9428, 54),
      ))
    }

@delegate:ResourceContentHash(590_430_256)
internal val Res.string.profile_row_export_subtitle: StringResource by lazy {
      StringResource("string:profile_row_export_subtitle", "profile_row_export_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9328, 99),
      ))
    }

@delegate:ResourceContentHash(-1_698_555_130)
internal val Res.string.profile_row_feedback: StringResource by lazy {
      StringResource("string:profile_row_feedback", "profile_row_feedback", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9565, 48),
      ))
    }

@delegate:ResourceContentHash(-300_285_900)
internal val Res.string.profile_row_feedback_subtitle: StringResource by lazy {
      StringResource("string:profile_row_feedback_subtitle", "profile_row_feedback_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9483, 81),
      ))
    }

@delegate:ResourceContentHash(-763_281_757)
internal val Res.string.profile_row_my_trees: StringResource by lazy {
      StringResource("string:profile_row_my_trees", "profile_row_my_trees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9692, 44),
      ))
    }

@delegate:ResourceContentHash(1_742_055_982)
internal val Res.string.profile_row_my_trees_subtitle: StringResource by lazy {
      StringResource("string:profile_row_my_trees_subtitle", "profile_row_my_trees_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9614, 77),
      ))
    }

@delegate:ResourceContentHash(-2_110_396_885)
internal val Res.string.profile_row_premium: StringResource by lazy {
      StringResource("string:profile_row_premium", "profile_row_premium", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9826, 35),
      ))
    }

@delegate:ResourceContentHash(-601_469_621)
internal val Res.string.profile_row_premium_subtitle: StringResource by lazy {
      StringResource("string:profile_row_premium_subtitle", "profile_row_premium_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9737, 88),
      ))
    }

@delegate:ResourceContentHash(1_523_433_647)
internal val Res.string.profile_row_rewarded_ad: StringResource by lazy {
      StringResource("string:profile_row_rewarded_ad", "profile_row_rewarded_ad", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10029, 83),
      ))
    }

@delegate:ResourceContentHash(910_181_553)
internal val Res.string.profile_row_rewarded_ad_loading: StringResource by lazy {
      StringResource("string:profile_row_rewarded_ad_loading", "profile_row_rewarded_ad_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9862, 75),
      ))
    }

@delegate:ResourceContentHash(-1_963_355_632)
internal val Res.string.profile_row_rewarded_ad_validating: StringResource by lazy {
      StringResource("string:profile_row_rewarded_ad_validating", "profile_row_rewarded_ad_validating", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9938, 90),
      ))
    }

@delegate:ResourceContentHash(1_578_946_115)
internal val Res.string.profile_row_settings: StringResource by lazy {
      StringResource("string:profile_row_settings", "profile_row_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10113, 40),
      ))
    }

@delegate:ResourceContentHash(331_872_900)
internal val Res.string.profile_row_support_subtitle: StringResource by lazy {
      StringResource("string:profile_row_support_subtitle", "profile_row_support_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10154, 104),
      ))
    }

@delegate:ResourceContentHash(534_237_835)
internal val Res.string.profile_row_support_title: StringResource by lazy {
      StringResource("string:profile_row_support_title", "profile_row_support_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10259, 53),
      ))
    }

@delegate:ResourceContentHash(-1_693_728_645)
internal val Res.string.profile_section_account: StringResource by lazy {
      StringResource("string:profile_section_account", "profile_section_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10313, 39),
      ))
    }

@delegate:ResourceContentHash(-1_151_088_271)
internal val Res.string.profile_section_activity: StringResource by lazy {
      StringResource("string:profile_section_activity", "profile_section_activity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10353, 52),
      ))
    }

@delegate:ResourceContentHash(-478_899_239)
internal val Res.string.profile_title: StringResource by lazy {
      StringResource("string:profile_title", "profile_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10406, 29),
      ))
    }

@delegate:ResourceContentHash(-1_765_553_915)
internal val Res.string.profile_trees_shared_plural: StringResource by lazy {
      StringResource("string:profile_trees_shared_plural", "profile_trees_shared_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10436, 59),
      ))
    }

@delegate:ResourceContentHash(2_012_434_349)
internal val Res.string.profile_trees_shared_singular: StringResource by lazy {
      StringResource("string:profile_trees_shared_singular", "profile_trees_shared_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10496, 57),
      ))
    }

@delegate:ResourceContentHash(-1_197_925_158)
internal val Res.string.profile_version: StringResource by lazy {
      StringResource("string:profile_version", "profile_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10554, 35),
      ))
    }

@delegate:ResourceContentHash(936_222_993)
internal val Res.string.settings_row_contact: StringResource by lazy {
      StringResource("string:settings_row_contact", "settings_row_contact", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10590, 44),
      ))
    }

@delegate:ResourceContentHash(-70_371_083)
internal val Res.string.settings_row_help: StringResource by lazy {
      StringResource("string:settings_row_help", "settings_row_help", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10635, 45),
      ))
    }

@delegate:ResourceContentHash(-1_417_136_876)
internal val Res.string.settings_row_legal_notice: StringResource by lazy {
      StringResource("string:settings_row_legal_notice", "settings_row_legal_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10681, 57),
      ))
    }

@delegate:ResourceContentHash(1_390_928_325)
internal val Res.string.settings_row_notifications: StringResource by lazy {
      StringResource("string:settings_row_notifications", "settings_row_notifications", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10739, 54),
      ))
    }

@delegate:ResourceContentHash(-255_222_095)
internal val Res.string.settings_row_privacy: StringResource by lazy {
      StringResource("string:settings_row_privacy", "settings_row_privacy", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10794, 52),
      ))
    }

@delegate:ResourceContentHash(-769_220_284)
internal val Res.string.settings_row_safety: StringResource by lazy {
      StringResource("string:settings_row_safety", "settings_row_safety", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10847, 67),
      ))
    }

@delegate:ResourceContentHash(-1_907_378_210)
internal val Res.string.settings_row_showcase: StringResource by lazy {
      StringResource("string:settings_row_showcase", "settings_row_showcase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10915, 57),
      ))
    }

@delegate:ResourceContentHash(2_129_401_659)
internal val Res.string.settings_row_terms: StringResource by lazy {
      StringResource("string:settings_row_terms", "settings_row_terms", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10973, 58),
      ))
    }

@delegate:ResourceContentHash(-247_013_562)
internal val Res.string.settings_section_legal: StringResource by lazy {
      StringResource("string:settings_section_legal", "settings_section_legal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11032, 58),
      ))
    }

@delegate:ResourceContentHash(1_578_946_115)
internal val Res.string.settings_title: StringResource by lazy {
      StringResource("string:settings_title", "settings_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11091, 34),
      ))
    }

@delegate:ResourceContentHash(1_612_078_616)
internal val Res.string.settings_version_label: StringResource by lazy {
      StringResource("string:settings_version_label", "settings_version_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11126, 42),
      ))
    }

@delegate:ResourceContentHash(454_034_882)
internal val Res.string.showcase_button_disabled: StringResource by lazy {
      StringResource("string:showcase_button_disabled", "showcase_button_disabled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11169, 44),
      ))
    }

@delegate:ResourceContentHash(-1_963_643_428)
internal val Res.string.showcase_button_filled: StringResource by lazy {
      StringResource("string:showcase_button_filled", "showcase_button_filled", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11214, 38),
      ))
    }

@delegate:ResourceContentHash(1_137_302_084)
internal val Res.string.showcase_button_loading: StringResource by lazy {
      StringResource("string:showcase_button_loading", "showcase_button_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11253, 47),
      ))
    }

@delegate:ResourceContentHash(1_011_781_310)
internal val Res.string.showcase_button_outline: StringResource by lazy {
      StringResource("string:showcase_button_outline", "showcase_button_outline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11301, 43),
      ))
    }

@delegate:ResourceContentHash(659_258_956)
internal val Res.string.showcase_button_text: StringResource by lazy {
      StringResource("string:showcase_button_text", "showcase_button_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11345, 36),
      ))
    }

@delegate:ResourceContentHash(-111_262_319)
internal val Res.string.showcase_button_tonal: StringResource by lazy {
      StringResource("string:showcase_button_tonal", "showcase_button_tonal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11382, 37),
      ))
    }

@delegate:ResourceContentHash(-1_854_729_018)
internal val Res.string.showcase_chip_apples: StringResource by lazy {
      StringResource("string:showcase_chip_apples", "showcase_chip_apples", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11420, 36),
      ))
    }

@delegate:ResourceContentHash(-1_858_372_169)
internal val Res.string.showcase_chip_pears: StringResource by lazy {
      StringResource("string:showcase_chip_pears", "showcase_chip_pears", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11457, 35),
      ))
    }

@delegate:ResourceContentHash(-1_082_357_058)
internal val Res.string.showcase_chip_selected: StringResource by lazy {
      StringResource("string:showcase_chip_selected", "showcase_chip_selected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11493, 46),
      ))
    }

@delegate:ResourceContentHash(-282_768_070)
internal val Res.string.showcase_chip_unselected: StringResource by lazy {
      StringResource("string:showcase_chip_unselected", "showcase_chip_unselected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11540, 52),
      ))
    }

@delegate:ResourceContentHash(-477_880_949)
internal val Res.string.showcase_empty_message: StringResource by lazy {
      StringResource("string:showcase_empty_message", "showcase_empty_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11593, 110),
      ))
    }

@delegate:ResourceContentHash(-1_752_104_623)
internal val Res.string.showcase_empty_title: StringResource by lazy {
      StringResource("string:showcase_empty_title", "showcase_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11704, 44),
      ))
    }

@delegate:ResourceContentHash(-563_280_121)
internal val Res.string.showcase_error_message: StringResource by lazy {
      StringResource("string:showcase_error_message", "showcase_error_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11749, 110),
      ))
    }

@delegate:ResourceContentHash(-1_659_486_258)
internal val Res.string.showcase_field_address: StringResource by lazy {
      StringResource("string:showcase_field_address", "showcase_field_address", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11860, 42),
      ))
    }

@delegate:ResourceContentHash(-1_254_232_875)
internal val Res.string.showcase_field_error_message: StringResource by lazy {
      StringResource("string:showcase_field_error_message", "showcase_field_error_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11903, 72),
      ))
    }

@delegate:ResourceContentHash(-1_406_609_071)
internal val Res.string.showcase_field_tree_name: StringResource by lazy {
      StringResource("string:showcase_field_tree_name", "showcase_field_tree_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11976, 52),
      ))
    }

@delegate:ResourceContentHash(-507_040_867)
internal val Res.string.showcase_section_badges: StringResource by lazy {
      StringResource("string:showcase_section_badges", "showcase_section_badges", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12029, 39),
      ))
    }

@delegate:ResourceContentHash(1_102_877_927)
internal val Res.string.showcase_section_buttons: StringResource by lazy {
      StringResource("string:showcase_section_buttons", "showcase_section_buttons", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12069, 44),
      ))
    }

@delegate:ResourceContentHash(-1_316_903_109)
internal val Res.string.showcase_section_cards: StringResource by lazy {
      StringResource("string:showcase_section_cards", "showcase_section_cards", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12114, 38),
      ))
    }

@delegate:ResourceContentHash(-351_852_834)
internal val Res.string.showcase_section_chips: StringResource by lazy {
      StringResource("string:showcase_section_chips", "showcase_section_chips", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12153, 38),
      ))
    }

@delegate:ResourceContentHash(-359_255_697)
internal val Res.string.showcase_section_fields: StringResource by lazy {
      StringResource("string:showcase_section_fields", "showcase_section_fields", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12192, 39),
      ))
    }

@delegate:ResourceContentHash(768_371_366)
internal val Res.string.showcase_section_season_strip: StringResource by lazy {
      StringResource("string:showcase_section_season_strip", "showcase_section_season_strip", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12232, 57),
      ))
    }

@delegate:ResourceContentHash(-1_975_704_232)
internal val Res.string.showcase_section_species_glyphs: StringResource by lazy {
      StringResource("string:showcase_section_species_glyphs", "showcase_section_species_glyphs", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12290, 87),
      ))
    }

@delegate:ResourceContentHash(119_159_312)
internal val Res.string.showcase_section_states: StringResource by lazy {
      StringResource("string:showcase_section_states", "showcase_section_states", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12378, 39),
      ))
    }

@delegate:ResourceContentHash(1_861_061_919)
internal val Res.string.showcase_title: StringResource by lazy {
      StringResource("string:showcase_title", "showcase_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12418, 42),
      ))
    }

@delegate:ResourceContentHash(541_930_343)
internal val Res.string.showcase_tree_cherry_meta: StringResource by lazy {
      StringResource("string:showcase_tree_cherry_meta", "showcase_tree_cherry_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12461, 73),
      ))
    }

@delegate:ResourceContentHash(878_572_436)
internal val Res.string.showcase_tree_cherry_name: StringResource by lazy {
      StringResource("string:showcase_tree_cherry_name", "showcase_tree_cherry_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12535, 61),
      ))
    }

@delegate:ResourceContentHash(43_369_794)
internal val Res.string.showcase_tree_favorite_meta: StringResource by lazy {
      StringResource("string:showcase_tree_favorite_meta", "showcase_tree_favorite_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12597, 63),
      ))
    }

@delegate:ResourceContentHash(619_864_842)
internal val Res.string.showcase_tree_favorite_name: StringResource by lazy {
      StringResource("string:showcase_tree_favorite_name", "showcase_tree_favorite_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12661, 55),
      ))
    }

@delegate:ResourceContentHash(-397_632_831)
internal val Res.string.showcase_tree_fig_meta: StringResource by lazy {
      StringResource("string:showcase_tree_fig_meta", "showcase_tree_fig_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12717, 74),
      ))
    }

@delegate:ResourceContentHash(1_222_598_770)
internal val Res.string.showcase_tree_fig_name: StringResource by lazy {
      StringResource("string:showcase_tree_fig_name", "showcase_tree_fig_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12792, 50),
      ))
    }

@delegate:ResourceContentHash(279_396_013)
internal val Res.string.showcase_tree_park_meta: StringResource by lazy {
      StringResource("string:showcase_tree_park_meta", "showcase_tree_park_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12843, 79),
      ))
    }

@delegate:ResourceContentHash(1_101_804_692)
internal val Res.string.showcase_tree_park_name: StringResource by lazy {
      StringResource("string:showcase_tree_park_name", "showcase_tree_park_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12923, 51),
      ))
    }

@delegate:ResourceContentHash(53_455_470)
internal val Res.string.showcase_tree_pear_meta: StringResource by lazy {
      StringResource("string:showcase_tree_pear_meta", "showcase_tree_pear_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12975, 71),
      ))
    }

@delegate:ResourceContentHash(-624_624_195)
internal val Res.string.showcase_tree_pear_name: StringResource by lazy {
      StringResource("string:showcase_tree_pear_name", "showcase_tree_pear_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13047, 55),
      ))
    }

@delegate:ResourceContentHash(1_398_945_923)
internal val Res.string.showcase_tree_walnut_meta: StringResource by lazy {
      StringResource("string:showcase_tree_walnut_meta", "showcase_tree_walnut_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13103, 73),
      ))
    }

@delegate:ResourceContentHash(478_184_076)
internal val Res.string.showcase_tree_walnut_name: StringResource by lazy {
      StringResource("string:showcase_tree_walnut_name", "showcase_tree_walnut_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13177, 53),
      ))
    }

@delegate:ResourceContentHash(-358_296_412)
internal val Res.string.splash_tagline: StringResource by lazy {
      StringResource("string:splash_tagline", "splash_tagline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13231, 74),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.storage_unavailable_dismiss: StringResource by lazy {
      StringResource("string:storage_unavailable_dismiss", "storage_unavailable_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13306, 43),
      ))
    }

@delegate:ResourceContentHash(1_266_469_632)
internal val Res.string.storage_unavailable_notice: StringResource by lazy {
      StringResource("string:storage_unavailable_notice", "storage_unavailable_notice", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13350, 150),
      ))
    }

@delegate:ResourceContentHash(250_983_216)
internal val Res.string.support_prompt_amount_10: StringResource by lazy {
      StringResource("string:support_prompt_amount_10", "support_prompt_amount_10", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13501, 40),
      ))
    }

@delegate:ResourceContentHash(-1_698_772_282)
internal val Res.string.support_prompt_amount_20: StringResource by lazy {
      StringResource("string:support_prompt_amount_20", "support_prompt_amount_20", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13542, 40),
      ))
    }

@delegate:ResourceContentHash(1_195_546_938)
internal val Res.string.support_prompt_amount_5: StringResource by lazy {
      StringResource("string:support_prompt_amount_5", "support_prompt_amount_5", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13583, 39),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.support_prompt_close_description: StringResource by lazy {
      StringResource("string:support_prompt_close_description", "support_prompt_close_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13623, 48),
      ))
    }

@delegate:ResourceContentHash(774_279_726)
internal val Res.string.support_prompt_context_contribution: StringResource by lazy {
      StringResource("string:support_prompt_context_contribution", "support_prompt_context_contribution", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13672, 131),
      ))
    }

@delegate:ResourceContentHash(-671_326_535)
internal val Res.string.support_prompt_context_harvest: StringResource by lazy {
      StringResource("string:support_prompt_context_harvest", "support_prompt_context_harvest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13804, 134),
      ))
    }

@delegate:ResourceContentHash(534_237_835)
internal val Res.string.support_prompt_link_out_cta: StringResource by lazy {
      StringResource("string:support_prompt_link_out_cta", "support_prompt_link_out_cta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13939, 55),
      ))
    }

@delegate:ResourceContentHash(-826_205_735)
internal val Res.string.support_prompt_opt_out: StringResource by lazy {
      StringResource("string:support_prompt_opt_out", "support_prompt_opt_out", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13995, 58),
      ))
    }

@delegate:ResourceContentHash(168_819_005)
internal val Res.string.support_prompt_other_amount: StringResource by lazy {
      StringResource("string:support_prompt_other_amount", "support_prompt_other_amount", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14054, 55),
      ))
    }

@delegate:ResourceContentHash(1_973_350_792)
internal val Res.string.support_prompt_title: StringResource by lazy {
      StringResource("string:support_prompt_title", "support_prompt_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14110, 64),
      ))
    }

@delegate:ResourceContentHash(-1_295_831_611)
internal val Res.string.userprofile_harvests_organized_plural: StringResource by lazy {
      StringResource("string:userprofile_harvests_organized_plural", "userprofile_harvests_organized_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14175, 73),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("profile_logout_all_dialog_text", Res.string.profile_logout_all_dialog_text)
  map.put("profile_logout_all_dialog_title", Res.string.profile_logout_all_dialog_title)
  map.put("profile_logout_all_done", Res.string.profile_logout_all_done)
  map.put("profile_member_since", Res.string.profile_member_since)
  map.put("profile_nudge_dismiss", Res.string.profile_nudge_dismiss)
  map.put("profile_nudge_enrich_cta", Res.string.profile_nudge_enrich_cta)
  map.put("profile_nudge_enrich_text", Res.string.profile_nudge_enrich_text)
  map.put("profile_nudge_enrich_title", Res.string.profile_nudge_enrich_title)
  map.put("profile_nudge_first_cta", Res.string.profile_nudge_first_cta)
  map.put("profile_nudge_first_text", Res.string.profile_nudge_first_text)
  map.put("profile_nudge_first_title", Res.string.profile_nudge_first_title)
  map.put("profile_row_activity", Res.string.profile_row_activity)
  map.put("profile_row_activity_subtitle", Res.string.profile_row_activity_subtitle)
  map.put("profile_row_ad_choices", Res.string.profile_row_ad_choices)
  map.put("profile_row_ad_choices_subtitle", Res.string.profile_row_ad_choices_subtitle)
  map.put("profile_row_blocked_users", Res.string.profile_row_blocked_users)
  map.put("profile_row_blocked_users_subtitle", Res.string.profile_row_blocked_users_subtitle)
  map.put("profile_row_delete_account", Res.string.profile_row_delete_account)
  map.put("profile_row_export", Res.string.profile_row_export)
  map.put("profile_row_export_subtitle", Res.string.profile_row_export_subtitle)
  map.put("profile_row_feedback", Res.string.profile_row_feedback)
  map.put("profile_row_feedback_subtitle", Res.string.profile_row_feedback_subtitle)
  map.put("profile_row_my_trees", Res.string.profile_row_my_trees)
  map.put("profile_row_my_trees_subtitle", Res.string.profile_row_my_trees_subtitle)
  map.put("profile_row_premium", Res.string.profile_row_premium)
  map.put("profile_row_premium_subtitle", Res.string.profile_row_premium_subtitle)
  map.put("profile_row_rewarded_ad", Res.string.profile_row_rewarded_ad)
  map.put("profile_row_rewarded_ad_loading", Res.string.profile_row_rewarded_ad_loading)
  map.put("profile_row_rewarded_ad_validating", Res.string.profile_row_rewarded_ad_validating)
  map.put("profile_row_settings", Res.string.profile_row_settings)
  map.put("profile_row_support_subtitle", Res.string.profile_row_support_subtitle)
  map.put("profile_row_support_title", Res.string.profile_row_support_title)
  map.put("profile_section_account", Res.string.profile_section_account)
  map.put("profile_section_activity", Res.string.profile_section_activity)
  map.put("profile_title", Res.string.profile_title)
  map.put("profile_trees_shared_plural", Res.string.profile_trees_shared_plural)
  map.put("profile_trees_shared_singular", Res.string.profile_trees_shared_singular)
  map.put("profile_version", Res.string.profile_version)
  map.put("settings_row_contact", Res.string.settings_row_contact)
  map.put("settings_row_help", Res.string.settings_row_help)
  map.put("settings_row_legal_notice", Res.string.settings_row_legal_notice)
  map.put("settings_row_notifications", Res.string.settings_row_notifications)
  map.put("settings_row_privacy", Res.string.settings_row_privacy)
  map.put("settings_row_safety", Res.string.settings_row_safety)
  map.put("settings_row_showcase", Res.string.settings_row_showcase)
  map.put("settings_row_terms", Res.string.settings_row_terms)
  map.put("settings_section_legal", Res.string.settings_section_legal)
  map.put("settings_title", Res.string.settings_title)
  map.put("settings_version_label", Res.string.settings_version_label)
  map.put("showcase_button_disabled", Res.string.showcase_button_disabled)
  map.put("showcase_button_filled", Res.string.showcase_button_filled)
  map.put("showcase_button_loading", Res.string.showcase_button_loading)
  map.put("showcase_button_outline", Res.string.showcase_button_outline)
  map.put("showcase_button_text", Res.string.showcase_button_text)
  map.put("showcase_button_tonal", Res.string.showcase_button_tonal)
  map.put("showcase_chip_apples", Res.string.showcase_chip_apples)
  map.put("showcase_chip_pears", Res.string.showcase_chip_pears)
  map.put("showcase_chip_selected", Res.string.showcase_chip_selected)
  map.put("showcase_chip_unselected", Res.string.showcase_chip_unselected)
  map.put("showcase_empty_message", Res.string.showcase_empty_message)
  map.put("showcase_empty_title", Res.string.showcase_empty_title)
  map.put("showcase_error_message", Res.string.showcase_error_message)
  map.put("showcase_field_address", Res.string.showcase_field_address)
  map.put("showcase_field_error_message", Res.string.showcase_field_error_message)
  map.put("showcase_field_tree_name", Res.string.showcase_field_tree_name)
  map.put("showcase_section_badges", Res.string.showcase_section_badges)
  map.put("showcase_section_buttons", Res.string.showcase_section_buttons)
  map.put("showcase_section_cards", Res.string.showcase_section_cards)
  map.put("showcase_section_chips", Res.string.showcase_section_chips)
  map.put("showcase_section_fields", Res.string.showcase_section_fields)
  map.put("showcase_section_season_strip", Res.string.showcase_section_season_strip)
  map.put("showcase_section_species_glyphs", Res.string.showcase_section_species_glyphs)
  map.put("showcase_section_states", Res.string.showcase_section_states)
  map.put("showcase_title", Res.string.showcase_title)
  map.put("showcase_tree_cherry_meta", Res.string.showcase_tree_cherry_meta)
  map.put("showcase_tree_cherry_name", Res.string.showcase_tree_cherry_name)
  map.put("showcase_tree_favorite_meta", Res.string.showcase_tree_favorite_meta)
  map.put("showcase_tree_favorite_name", Res.string.showcase_tree_favorite_name)
  map.put("showcase_tree_fig_meta", Res.string.showcase_tree_fig_meta)
  map.put("showcase_tree_fig_name", Res.string.showcase_tree_fig_name)
  map.put("showcase_tree_park_meta", Res.string.showcase_tree_park_meta)
  map.put("showcase_tree_park_name", Res.string.showcase_tree_park_name)
  map.put("showcase_tree_pear_meta", Res.string.showcase_tree_pear_meta)
  map.put("showcase_tree_pear_name", Res.string.showcase_tree_pear_name)
  map.put("showcase_tree_walnut_meta", Res.string.showcase_tree_walnut_meta)
  map.put("showcase_tree_walnut_name", Res.string.showcase_tree_walnut_name)
  map.put("splash_tagline", Res.string.splash_tagline)
  map.put("storage_unavailable_dismiss", Res.string.storage_unavailable_dismiss)
  map.put("storage_unavailable_notice", Res.string.storage_unavailable_notice)
  map.put("support_prompt_amount_10", Res.string.support_prompt_amount_10)
  map.put("support_prompt_amount_20", Res.string.support_prompt_amount_20)
  map.put("support_prompt_amount_5", Res.string.support_prompt_amount_5)
  map.put("support_prompt_close_description", Res.string.support_prompt_close_description)
  map.put("support_prompt_context_contribution", Res.string.support_prompt_context_contribution)
  map.put("support_prompt_context_harvest", Res.string.support_prompt_context_harvest)
  map.put("support_prompt_link_out_cta", Res.string.support_prompt_link_out_cta)
  map.put("support_prompt_opt_out", Res.string.support_prompt_opt_out)
  map.put("support_prompt_other_amount", Res.string.support_prompt_other_amount)
  map.put("support_prompt_title", Res.string.support_prompt_title)
  map.put("userprofile_harvests_organized_plural", Res.string.userprofile_harvests_organized_plural)
}
